export default __webpack_public_path__ + "static/media/EAST1070.34I-34195_-18440_0.5233421c.jpg";